export default {"src":"/_next/static/media/element.8d38298a.svg","height":28,"width":28};